{
  "HubViewBuilders": "Hub View Builders",
  "backToBuilders": "back to all builders",
  "AssignmentIdeas": "Assignment Ideas",
  "BuildersOutline": "Builders Outline",
  "LessonPlanning": "Lesson Planning",
  "RebelbaseCurriculum": "Rebelbase Curriculum",
  "IntroTo": "Intro to ",
  "next": "Next",
  "OverviewOf": "Overview of ",
  "steps": "steps",
  "Introduction": "Introduction",
  "Answer": "Answer",
  "Go": "Go >",
  "Review+Publish": "Review + Publish",
  "backToTopics": "back to topics",
  "NoteToHubAdmins": "Note to hub admins: ",
  "NoteToHubAdminsPhrase": "Your members will be able to add their answer below. This answer will display in their project profile when they publish the builder.",
  "skipToAnswer": "skip to answer",
  "back": "back",
  "GotItNext": "Got it, next",
  "Brief": "Brief",
  "InspirationByte": "Inspiration Byte",
  "Workshop": "Workshop",
  "Section": "Section",
  "difficultyLevel": "difficulty level: ",
  "OnTrack": "On Track:",
  "FaciliationTools": "Faciliation Tools",
  "FaciliationTools1": "Hub Launch Guide",
  "FaciliationTools2": "The RebelBase Curriculum, Builders and Hubs",
  "ChooseYourBuilder": "Choose Your Builder",
  "Group": "Group",
  "changeThisAtAnyTime": "change this at any time",
  "Track": "Track",
  "HubView": "Hub View",
  "Builders": "BUILDERS",
  "InGroup": "In Group: ",
  "switchTracksOrGroup": "switch track or group",
  "switchTrack": "switch track",
  "HubViewPhrase1": "This is your space to explore RebelBase builders.",
  "readMore": "read more...",
  "HubViewPhrase2Part1": "This view you see here matches what your hub's innovators see. ",
  "HubViewPhrase2Part2": "Go ahead and delve into the content to better understand how to incorporate it into your program. ",
  "HubViewPhrase2Part3": "In addition, we've provided a set of facilitation tools filled with useful tips and recommendations on how to apply the builders in varied contexts."
}
